"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Context = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _imageUrl = _interopRequireDefault(require("@sanity/image-url"));

var _client = _interopRequireDefault(require("@sanity/client"));

var _groqs = require("./groqs");

var _reducer = _interopRequireWildcard(require("../data/reducer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _objectSpread2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Context = (0, _react.createContext)({});
exports.Context = Context;
var initialState = {
  documents: {},
  types: {},
  queries: {}
};

var SanityProvider = function SanityProvider(_ref) {
  var children = _ref.children,
      projectId = _ref.projectId,
      dataset = _ref.dataset,
      useCdn = _ref.useCdn,
      serializers = _ref.serializers,
      withCredentials = _ref.withCredentials;

  var _useReducer = (0, _react.useReducer)(_reducer["default"], initialState),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      data = _useReducer2[0],
      dispatch = _useReducer2[1];

  var client = (0, _client["default"])({
    projectId: projectId,
    dataset: dataset,
    useCdn: useCdn,
    withCredentials: withCredentials
  });
  var builder = (0, _imageUrl["default"])(client);

  var getImageUrl = function getImageUrl(image) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return builder.image(image).withOptions(options).url();
  };

  var getDocument =
  /*#__PURE__*/
  function () {
    var _ref2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(id) {
      var document;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!data.documents[id]) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              _context.next = 4;
              return client.fetch((0, _groqs.groqGetDocumentById)(), {
                id: id
              });

            case 4:
              document = _context.sent;
              dispatch({
                type: _reducer.actionTypes.setDocument,
                document: document
              });

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function getDocument(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var getType =
  /*#__PURE__*/
  function () {
    var _ref3 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee2(type) {
      var documents;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!data.types[type]) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return");

            case 2:
              _context2.next = 4;
              return client.fetch((0, _groqs.groqGetType)(), {
                type: type
              });

            case 4:
              documents = _context2.sent;
              dispatch({
                type: _reducer.actionTypes.setType,
                documents: documents,
                documentType: type
              });

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function getType(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  var query =
  /*#__PURE__*/
  function () {
    var _ref4 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee3(groq, id, params) {
      var result;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!data.queries[groq]) {
                _context3.next = 2;
                break;
              }

              return _context3.abrupt("return");

            case 2:
              _context3.next = 4;
              return client.fetch(groq, params);

            case 4:
              result = _context3.sent;
              dispatch({
                type: _reducer.actionTypes.fetch,
                result: result,
                id: id
              });

            case 6:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function query(_x3, _x4, _x5) {
      return _ref4.apply(this, arguments);
    };
  }();

  var value = (0, _react.useMemo)(function () {
    return data;
  }, [data]);
  return _react["default"].createElement(Context.Provider, {
    value: _objectSpread2({}, value, {
      getImageUrl: getImageUrl,
      buildImage: builder.image,
      getDocument: getDocument,
      getType: getType,
      query: query,
      sanityOptions: {
        projectId: projectId,
        dataset: dataset
      },
      serializers: serializers,
      fetch: client ? client.fetch : null
    })
  }, children);
};

var _default = SanityProvider;
exports["default"] = _default;
SanityProvider.propTypes = {
  children: _propTypes["default"].any.isRequired,
  dataset: _propTypes["default"].string.isRequired,
  projectId: _propTypes["default"].string.isRequired,
  useCdn: _propTypes["default"].bool,
  withCredentials: _propTypes["default"].bool
};
SanityProvider.defaultProps = {
  useCdn: true,
  withCredentials: false
};